import script from "./FRemoveReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./FRemoveReport.vue?vue&type=script&setup=true&lang=ts"

import "./FRemoveReport.vue?vue&type=style&index=0&id=709f028e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709f028e"]])

export default __exports__